module.exports = __webpack_public_path__ + "img/right-arrow.e5467cff.svg";